import * as p from "./../../package.json";

export function useAppInformation() {
  return {
    version: p.version,
    applicationName: p.description,
  };
}
